import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/tooltip.module.scss'

type Props = {
  open: boolean
  children: ReactNode
}

const TooltipWrapper: FC<Props> = ({ children, open }) => {
  return <div className={open ? `${styles.open} ${styles.tooltip}` : styles.tooltip}>{children}</div>
}

export default TooltipWrapper
